module.exports = __webpack_public_path__ + "img/aboutus01.b8a68bc5.png";